import React from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

const AccessManagementTableSkeleton = ({ docsPerPage }) => {
	return (
		<div className="bg-white rounded-lg overflow-auto mb-4">
			<table className="min-w-[700px] xl:min-w-full">
				<thead className="bg-[#F2F3F7]">
					<tr>
						<th
							scope="col"
							className="px-5 py-4 text-lg leading-100 font-medium text-gray text-left"
						>
							NAME
						</th>
						<th
							scope="col"
							className="px-5 py-4 text-lg leading-100 font-medium text-gray text-left"
						>
							EMAIL
						</th>
						<th
							scope="col"
							className="px-5 py-4 text-lg leading-100 font-medium text-gray text-left"
						>
							ROLE
						</th>
						<th
							scope="col"
							className="px-5 py-4 text-lg leading-100 font-medium text-gray text-left"
						>
							STATUS
						</th>
						<th
							scope="col"
							className="px-5 py-4 text-lg leading-100 font-medium text-gray text-left"
						>
							ACTIONS
						</th>
					</tr>
				</thead>
				<tbody className="bg-white">
					{[...Array(docsPerPage)].map((_, index) => (
						<tr key={index}>
							<td className="px-5 py-4 text-lg font-medium text-dark-blue leading-100">
								<Skeleton width={100} />
							</td>
							<td className="px-5 py-4 text-lg font-medium text-dark-blue leading-100">
								<Skeleton width={150} />
							</td>
							<td className="px-5 py-4 text-lg font-medium text-dark-blue leading-100">
								<Skeleton width={70} />
							</td>
							<td className="px-5 py-4 text-lg">
								<Skeleton width={60} />
							</td>
							<td className="px-5 py-4 text-lg">
								<div className="flex items-center space-x-2">
									<Skeleton circle width={22} height={22} />
									<Skeleton circle width={22} height={22} />
								</div>
							</td>
						</tr>
					))}
				</tbody>
			</table>
		</div>
	);
};

export default AccessManagementTableSkeleton;
